export const executeShipmentWorkflowDefault = '{\n' +
    '    "operation": "fakeShipGen",\n' +
    '    "orderId": "",\n' +
    '    "realm": "USAmazon"\n' +
    '}';

export enum ShipmentOperation {
    TRIGGER_PFW = "triggerPfw",
    FAKE_SHIP_GEN = "fakeShipGen",
    FAKE_SHIP_COMPLETE = "fakeShipComplete",
    FULL_SHIPMENT_FLOW = "fullShipmentFlow",
}

export const OPERATION_DESCRIPTIONS: Record<string, string> = {
    [ShipmentOperation.TRIGGER_PFW]: "Trigger Post-Fulfillment Workflow",
    [ShipmentOperation.FAKE_SHIP_GEN]: "Generate Fake Shipment",
    [ShipmentOperation.FAKE_SHIP_COMPLETE]: "Complete Fake Shipment",
    [ShipmentOperation.FULL_SHIPMENT_FLOW]: "Full End-to-End Shipment Flow",
};

export const OPERATION_OPTIONS = Object.entries(OPERATION_DESCRIPTIONS).map(([value, description]) => ({
    label: description,
    value,
    description: value,
}));

export interface IExecuteShipmentWorkflowRequest {
    operation: string;
    orderId?: string;
    shipmentId?: string;
    realm?: string;
}
